import { create } from 'zustand';

export enum HelpPages {
  Root = 0,
  ReportIssue = 1,
  ConfidentialHotline = 2,
  FAQ = 3
}

interface Store {
  page: HelpPages;
  open: boolean;
  setPage(page: HelpPages): void;
  toggle(open?: boolean): void;
}

export const useHelpStore = create<Store>((set, get) => ({
  page: HelpPages.Root,
  open: false,
  setPage: page => set({ page }),
  toggle: open => set({ open: open === undefined ? !get().open : open })
}));
